import { render, staticRenderFns } from "./AddQuestionnaire.vue?vue&type=template&id=316e1140&scoped=true&"
import script from "./AddQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AddQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionnaire.vue?vue&type=style&index=0&id=316e1140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e1140",
  null
  
)

export default component.exports